var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRotateLeft = function SvgArrowRotateLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.906 7H7.5c.531 0 1 .469 1 1 0 .563-.469 1-1 1h-4c-.562 0-1-.437-1-1V4c0-.531.438-1 1-1 .531 0 1 .469 1 1v1.625l.531-.562a7.035 7.035 0 0 1 9.907 0 7.036 7.036 0 0 1 0 9.906 7.035 7.035 0 0 1-9.907 0c-.375-.406-.375-1.031 0-1.406.407-.407 1.032-.407 1.407 0a5.055 5.055 0 0 0 7.093 0 5.055 5.055 0 0 0 0-7.094 5.055 5.055 0 0 0-7.094 0z"
  })));
};
export default SvgArrowRotateLeft;